import React, { useState, useRef } from "react";
import { useMsal } from '@azure/msal-react';
import { useNavigate } from "react-router-dom";
import { loginRequest } from '../authConfig';

export default function LoginForm() {
    const { instance } = useMsal();
    const navigate = useNavigate()
    const [isLogin, setIsLogin] = useState(false);

    const handleRedirect = () => {
        setIsLogin(true)

        instance
            .loginRedirect({
                ...loginRequest,
                prompt: 'create',
            })
            .catch((error) => console.log(error));
    };

    return (
        <div className="container text-center">
            <div className="row justify-content-md-center m-5">
                <img src="/assets/img/amway-logo.jpg" style={{ width: 300 }} alt="Logo" />
            </div>
            <div className="row justify-content-md-center m-5">
                <h5>Authentication by Entra ID</h5>

                <div className="card" style={{ width: '20rem' }}>
                    <div className="card-body">
                        <div className="mt-3">
                                {isLogin ?
                                    <button className="btn btn-black btn-border btn-sm" style={{ "width": "120" }} type="button">
                                        <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                        <span role="status" className="ms-3">Logging in ...</span>
                                    </button>
                                :
                                    <button type="button" className="btn btn-primary btn-sm" style={{ "width": "120" }} onClick={handleRedirect}> 
                                        <i class="bi bi-person-circle"></i> <span role="status">Login</span>
                                    </button>
                                }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}